export default function AddBrandToUrl(url, brandName) {
  return brandName && !url.includes('brand') ? url + `?brand=${brandName}`: url;
}
